<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrKontrolEylem from "@/models/StrKontrolEylem";
export default {
  mixins: [Api, Sabit, StrKontrolEylem],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.AddEdit == "Add") {
          this.Post("StrKontrolEylem", this.FormData);
          this.$bvModal.hide("StrKontrolEylem");
          this.$emit("TableUpdate");
        } else {
          this.Update("StrKontrolEylem", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.$bvModal.hide("StrKontrolEylem");
              this.$emit("TableUpdate");
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="StrKontrolEylem"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrKontrolEylem.AddEdit.FormTitleEdit')
          : $t('StrKontrolEylem.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <Form @submit.prevent="onSubmit">
        <forminput
          :FormDataType="FormDataType.SiraNo"
          :Value="FormData.SiraNo"
          :v="$v.FormData.SiraNo"
          @input="FormData.SiraNo = $event"
        />
        <forminput
          :FormDataType="FormDataType.Kod"
          :Value="FormData.Kod"
          :v="$v.FormData.Kod"
          @input="FormData.Kod = $event"
        />
        <forminput
          :FormDataType="FormDataType.Eylem"
          :Value="FormData.Eylem"
          :v="$v.FormData.Eylem"
          @input="FormData.Eylem = $event"
        />
        <button class="btn btn-primary" type="submit">
          {{ $t("StrKontrolEylem.AddEdit.Button") }}
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
